import { colors, COLORS } from '../../../../../constants/colors';

export const useStyles = () => ({
  avatar: {
    backgroundColor: COLORS.DARK_GREY,
    borderRadius: 72,
    m: 1,
    width: 56,
    height: 56,
    boxSizing: 'border-box',
  },
  stop: (currentSharing: boolean) => ({
    color: currentSharing
      ? `${colors.white} !important`
      : `${COLORS.ERROR} !important`,
  }),
  badge: (deviceId: boolean) => ({
    '& .MuiBadge-badge': {
      display: deviceId ? 'none' : 'flex',
      fontWeight: 'bold',
      right: -1,
    },
  }),
  milicast: {
    p: 2,
    width: 400,
  },
});
